// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb_qa0sg"};